import React, { useEffect, useRef, useState, useContext } from "react";
import "./index.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import { toast } from "react-toastify";
import axios from "../../axios";
import { API_CALL_URL_PRIVATE, DOMAIN_URL } from "../../constants/compensate";
import Texterror from "../Texterror";
import { StaffingGridCalculateValidation } from "../../utils/validator";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { ThemeContext } from "../../providers/ThemeProvider";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function AddReasonMaster() {
  const fileInputRef = useRef(null);
  const fileLogoInputRef = useRef(null);
  const [themeMode, setTheme] = useContext(ThemeContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  const [isLoading, setIsLoading] = useState(false);
  const [FormInitialData, setFormInitialData] = useState();

  const [isInitialData, setISInitialData] = useState(true);
  const [fieldConfig, setFieldConfig] = useState([]);
  const [initialValues, setInitialValues] = useState({ cost_center_number : "" });
  const [costCenterMaster, setCostCenterMaster] = useState(null);
  const [dropCostCenterMaster, setDropCostCenterMaster] = useState([]);
  const[patientFieldsMaster, setPatientFieldsMaster] = useState([]);

  const onSubmit = (values, onSubmittingProps) => {
    console.log("form Values", values);
    formSubmit(values);
    // setTimeout(() => {
    //   onSubmittingProps.setSubmitting(false);
    // }, [2000]);
  };
  const formSubmit = async (values) => {
    
    const obj = {
      ...values,
      customer_code: parseInt(customer_code),
    };
    

    try {
      setIsLoading(true);
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/staffingGridCalculated/create`,
        obj
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      navigate("/admin/staffing-grid-calculated");
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCostCenter = async () => {
    const resp = await axios.get(
      `${API_CALL_URL_PRIVATE}/staffingGridCalculated/costcenterlist?customer_code=${parseInt(
        customer_code
      )}`
    );

    setCostCenterMaster(
      resp?.data?.data?.data?.docs?.map((e) => {
        return {
          cost_center_name: e.cost_center_name,
          cost_center_number: e.cost_center_number,
        };
      })
    );
    // setISInitialData(true);
    const DropCost = resp?.data?.data?.map((e) => {
      return {
        label: `${e.cost_center_number} - ${e.cost_center_name}`,
        value: e.cost_center_number,
        isDisabled: !e.enable,
      };
    });
    setDropCostCenterMaster(DropCost);
  };


  const getpatientsfields = async (costcenter) => {
    const resp = await axios.get(
      `${API_CALL_URL_PRIVATE}/staffingGridCalculated/patientfields?customer_code=${parseInt(
        customer_code
      )}&cost_center_number=${costcenter}`
    );

    const fieldsFromAPI = resp?.data?.data?.patient_fields;

    const newInitialValues = {};
    fieldsFromAPI.forEach((item) => {
      newInitialValues[item.field_name] = "";
    });

    setFieldConfig(fieldsFromAPI);
    setInitialValues((prev) => ({
      ...prev,
      ...newInitialValues,
    }));
  };

  useEffect(() => {
    getCostCenter();
    // getpatientsfields();
  }, []);

  const getCustomSelectStyles = () => ({
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled
        ? themeMode.theme === "DARK"
          ? "#1A1C24"
          : "#f2f2f2"
        : state.isFocused
        ? themeMode.theme === "DARK"
          ? "#2A2D3A"
          : "#e6f0ff"
        : themeMode.theme === "DARK"
        ? "#1A1C24"
        : "#fff",
      color: state.isDisabled
        ? themeMode.theme === "DARK"
          ? "#888"
          : "#ccc"
        : themeMode.theme === "DARK"
        ? "#fff"
        : "#000",
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: themeMode.theme === "DARK" ? "#1A1C24" : "#fff",
      borderColor: themeMode.theme === "DARK" ? "#444" : "#ccc",
      color: themeMode.theme === "DARK" ? "#fff" : "#000",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: themeMode.theme === "DARK" ? "#fff" : "#000",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: themeMode.theme === "DARK" ? "#1A1C24" : "#fff",
    }),
  });

  console.log("patuu", initialValues);
  


  return (
    <>
      {isInitialData ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validate={(values) =>
            StaffingGridCalculateValidation(values, fieldConfig)
          }
          enableReinitialize
          validateOnChange
        >
          {(formik) => (
            <div className="main-panel">
              {console.log(formik)}
              <div className="content-wrapper">
                <div className="page-header">
                  <h3 className="page-title">
                    <a href="#" className="badge badge-dark"></a>
                  </h3>
                  <div className></div>
                </div>
                <div className="row">
                  <div class="col-12 grid-margin stretch-card">
                    <div class="card">
                      <FormikForm className="forms-sample">
                        <div class="card-body">
                          <div className="row align-items-center">
                            <div className="col-4">
                              <Link
                                to={`/admin/staffing-grid-calculated`}
                                className="f-14 white-text-dark-mode"
                              >
                                <FontAwesomeIcon icon="fa-solid fa-arrow-left " />{" "}
                                Back
                              </Link>
                            </div>
                            <div className="col-md-4">
                              <div
                                className="d-flex col"
                                style={{ maxWidth: "100%", margin: "0 auto" }}
                              >
                                <h5 class="m-0 fs-6 text-center mx-2">
                                  Cost Center
                                </h5>
                                <div
                                  className=""
                                  style={{ width: "calc(100% - 110px)" }}
                                  //   className="ms-4"
                                >
                                  <ReactSelect
                                    name="cost_center_number"
                                    isSearchable="true"
                                    options={dropCostCenterMaster}
                                    className="custom-select mx-2"
                                    styles={getCustomSelectStyles()}
                                    value={
                                      dropCostCenterMaster?.find(
                                        (option) =>
                                          option.value ===
                                          formik.values.cost_center_number
                                      ) || null
                                    }
                                    onChange={(e) => {
                                      // formik.setFieldTouched(
                                      //   "cost_center_number",
                                      //   true,
                                      //   true
                                      // );
                                      formik.setFieldValue(
                                        "cost_center_number",
                                        e.value || ""
                                      );

                                      setInitialValues((prev) => ({
                                        ...prev,
                                        cost_center_number: e.value,
                                      }));
                                      getpatientsfields(e.value);
                                    }}
                                    onBlur={() => {
                                      formik.setFieldTouched(
                                        "cost_center_number",
                                        true,
                                        true
                                      );
                                    }}
                                  />
                                  <ErrorMessage
                                    name="cost_center_number"
                                    className="mx-2"
                                    component={Texterror}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row mt-4">
                            {fieldConfig.map((field) => (
                              <Form.Group
                                key={field.field_name}
                                className="col-md-2 mb-3"
                                controlId={`field-${field.field_name}`}
                              >
                                <OverlayTrigger
                                  key={"top"}
                                  placement={"top"}
                                  overlay={
                                    <Tooltip id={`tooltip-${"top"}`}>
                                      <strong>{field?.field_name}</strong>
                                    </Tooltip>
                                  }
                                >
                                  <Form.Label>{field.field_label}</Form.Label>
                                </OverlayTrigger>
                                <Form.Control
                                  type="number"
                                  placeholder=""
                                  name={field.field_name}
                                  {...formik.getFieldProps(field.field_name)}
                                />
                                <ErrorMessage
                                  name={field.field_name}
                                  component={Texterror}
                                />
                              </Form.Group>
                            ))}

                            <Form.Group className="col-md-12 mb-3 d-flex justify-content-end">
                              <Button
                                className="ms-3"
                                variant="success"
                                type="submit"
                                disabled={isLoading}
                              >
                                {isLoading ? "Saving..." : "Save"}
                              </Button>
                            </Form.Group>
                          </div>
                        </div>
                      </FormikForm>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Formik>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100vw h-100vh">
          <span class="loader" style={{ width: "50px", height: "50px" }}></span>
        </div>
      )}
    </>
  );
}

export default AddReasonMaster;
